import { render, staticRenderFns } from "./model-filter-v3.vue?vue&type=template&id=b4e71554&scoped=true&"
import script from "./model-filter-v3.vue?vue&type=script&lang=js&"
export * from "./model-filter-v3.vue?vue&type=script&lang=js&"
import style0 from "./model-filter-v3.vue?vue&type=style&index=0&id=b4e71554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e71554",
  null
  
)

export default component.exports